import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';
import { Md5 } from 'ts-md5';
import { environment } from 'src/environments/environment';
import { UserService } from 'src/app/services/user.service';
import { take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UtilService } from 'src/app/services/util.service';
import { OrganisationService } from 'src/app/services/organisation.service';

const BackendUrl = environment.BackendUrl;

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  private authStatusListener = new Subject<boolean>();
  private cred_password: string;
  private credentials: string;
  private token: string;
  private userId: string;
  private userName: string;
  private orgid: string;
  private localOrgid: string;
  private isAuthenticated = false;
  private currentUser: any;

  constructor(private http: HttpClient, private router:Router, private userService: UserService,
              private utilService: UtilService, private organisationService: OrganisationService) {}

  /**
   * Group admins start in koncern mode (no company-admin elevation).
   * Company-admin rights are applied only after Change organisation sets groupAdminCompanyMode.
   */
  private prepareUserAfterLogin(user: any): any {
    if (!user) {
      return user;
    }
    const isGroupAdmin =
      user.is_group_admin === 1 ||
      user.is_group_admin === '1' ||
      user.is_group_admin === true;
    if (isGroupAdmin && user.group_id) {
      localStorage.removeItem('groupAdminCompanyMode');
    }
    return user;
  }

  private navigateAfterLogin(userData: any): void {
    const isGroupAdmin =
      userData?.is_group_admin === 1 ||
      userData?.is_group_admin === '1' ||
      userData?.is_group_admin === true;
    if (isGroupAdmin && userData?.group_id) {
      // Hard navigation so nothing (e.g. login page) can race to company routes
      window.location.href = '/koncern';
      return;
    }
    if (
      userData.is_admin == 1 ||
      userData.is_super_user == 1 ||
      userData.is_local_admin == 1 ||
      userData.is_maintenance_user == 1
    ) {
      this.router.navigate(['/dashboard']).then(() => {
        window.location.reload();
      });
    } else {
      this.router.navigate(['/productlist']).then(() => {
        window.location.reload();
      });
    }
  }

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Authorization': "",
      'Content-Type': 'application/json'
    })
  }

  getIsAuth() {
    const token = localStorage.getItem('token');
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser == null) {
      return false;
    }
    const userId = this.utilService.serialize(currentUser).id;
    const time = +localStorage.getItem('tokenTime')-Date.now();
    if(token && userId && time > 0){
      return true;
    }
    return false;
  }

  getAuthServiceListener() {
    return this.authStatusListener.asObservable();
  }

  loginSso(email) {
    window.location.href = BackendUrl + `/loginsso?email=${email}`;
  }

  login ( username, password, access_token, dep ) {
    if (access_token == null) {
      this.http.get<any>(BackendUrl + "/userinfo/" + username).pipe(take(1)).subscribe({
        next: response => {
          this.cred_password = Md5.hashStr(response + password || "")
          this.http.post<any>(BackendUrl + "/login/", { username: username, password: this.cred_password }).subscribe({
            next: response => {
              localStorage.setItem('token', response.token);
              this.userService.getCurrentUser(true);
              this.userService.getCurrentUserDataListener().pipe(take(1)).subscribe({
                next: userData => {
                  if (userData == null) {
                    this.authStatusListener.next(false);
                  }
                  else {
                    this.isAuthenticated = true;
                    userData = typeof userData === 'string' ? JSON.parse(userData) : userData;
                    userData = this.prepareUserAfterLogin(userData);
                    localStorage.setItem('currentUser', JSON.stringify(userData));
                    switch(userData.language) {
                      case 0 :
                        localStorage.setItem('usedLanguage', 'sv');
                      break;
                      case 1:
                        localStorage.setItem('usedLanguage', 'en');
                      break;
                      case 2:
                        localStorage.setItem('usedLanguage', 'fi');
                      break;
                      case 3:
                        localStorage.setItem('usedLanguage', 'no');
                      break;
                      case 4:
                        localStorage.setItem('usedLanguage', 'da');
                      break;
                      case 5:
                        localStorage.setItem('usedLanguage', 'zh');
                      break;
                      default:
                        localStorage.setItem('usedLanguage', 'sv');
                      break;
                    }
                    this.setTokenTime();
                    this.organisationService.getOrganisation(userData.root_organisation_id);
                    this.organisationService.getOrganisationOrgDataListener().pipe(take(1)).subscribe({
                      next: organisation => {
                        // A recursive function to get All departments of an organisation
                        // the function must be defined here but used later
                        let startPoint = organisation;
                        let searchId = [];
                        let idArray=[];
                        let allOrganisations=[];
                        idArray.push(organisation.id);
                        allOrganisations.push(organisation);

                          function getId (startPoint){
                            searchId.push(startPoint.id);
                            startPoint.orgs.forEach(element => {
                              if(searchId.indexOf(element.id)<0){
                                idArray.push(element.id);
                                allOrganisations.push(element);
                                getId(element);
                              }
                            });
                          }

                        if (organisation == null) {
                          this.authStatusListener.next(false);
                        }
                        else
                        {
                          localStorage.setItem('rootOrganisation', JSON.stringify(organisation));
                          localStorage.setItem('selectedOrganisation', JSON.stringify(organisation));

                          // Get all departments
                          getId(startPoint);


                          if (userData.is_local_user == 1 || userData.is_local_admin == 1 || userData.guest == 1 ||
                            (!userData.is_admin && !userData.is_super_user && !userData.is_super_admin && !userData.maintenance_user && !userData.readonly_user &&
                             !(userData.is_group_admin == 1 || userData.is_group_admin === true || userData.is_group_admin === '1'))) {

                            userData.LocalUserDepartments = [];

                            if ((!userData.department || userData.department.trim() == "" || userData.department==0)
                                && (!userData.is_local_user_department || userData.is_local_user_department.trim() == "" || userData.is_local_user_department==0)) {
                                userData.LocalUserDepartments.push(userData.root_organisation_id.trim());
                            } else {
                              userData.LocalUserDepartments.push(userData.department);
                              var departmentArrayTemp = userData.is_local_user_department.split(',');
                              for (let value of departmentArrayTemp) {
                                if (value != ""){
                                  userData.LocalUserDepartments.push(value.trim());
                                }
                              }

                              let needsToBeUpdated = false;
                              userData.LocalUserDepartments.forEach(element => {
                                if ( element == userData.root_organisation_id ){
                                  // Ignoring the root organisation
                                } else {
                                  let subOrgs = this.utilService.getAllSubdepartments(allOrganisations.find(org => org.id === element), true);
                                  if (typeof subOrgs === 'string') {
                                    subOrgs = [subOrgs];
                                  }
                                  if (Array.isArray(subOrgs)) {
                                    for (let value of subOrgs) {
                                      if (userData.LocalUserDepartments.indexOf(value) == -1) {
                                        needsToBeUpdated = true;
                                        userData.LocalUserDepartments.push(value.trim());
                                      }
                                    }
                                  }
                                }
                              });

                              if (needsToBeUpdated) {
                                // Updates the values in local storage
                                let tempUser = JSON.parse(localStorage.getItem('currentUser'));
                                tempUser.is_local_user_department = userData.LocalUserDepartments.join(',');
                                localStorage.setItem('currentUser', JSON.stringify(tempUser));
                              }
                            }
                            if ((userData.department != null) && (userData.department != '')) {
                              for (var j = 0; j < allOrganisations.length; j++) {
                                if (userData.department == allOrganisations[j].id) {
                                  localStorage.setItem('selectedDepartment', JSON.stringify(allOrganisations[j]));
                                  this.authStatusListener.next(true);
                                  //window.location.href = '/';
                                  this.navigateAfterLogin(userData);
                                }
                              }
                            }
                            else {
                              for (let i = 0; i < userData.LocalUserDepartments.length; i++) {
                                for (var j = 0; j < allOrganisations.length; j++) {
                                  if (userData.LocalUserDepartments[i] == allOrganisations[j].id) {
                                    localStorage.setItem('selectedDepartment', JSON.stringify(allOrganisations[j]));
                                    this.authStatusListener.next(true);
                                    //window.location.href = '/';
                                    this.navigateAfterLogin(userData);
                                  }
                                }
                              }
                            }
                          } else {
                            if ((userData.department != null) && (userData.department != '')) {
                              for (var j = 0; j < allOrganisations.length; j++) {
                                if (userData.department == allOrganisations[j].id) {
                                  localStorage.setItem('selectedDepartment', JSON.stringify(allOrganisations[j]));
                                  this.authStatusListener.next(true);
                                  //window.location.href = '/';
                                  this.navigateAfterLogin(userData);
                                }
                              }
                            }
                            else
                            {
                              localStorage.setItem('selectedDepartment', JSON.stringify(organisation));
                              this.authStatusListener.next(true);
                              //window.location.href = '/';
                              this.navigateAfterLogin(userData);
                            }
                          }
                        }
                      },
                      error: error => {
                        this.authStatusListener.next(false);
                      }
                    })
                  }
                },
                error: error => {
                  this.authStatusListener.next(false);
                }
              })
            },
            error: error => {
              this.authStatusListener.next(false);
            }
          })
        },
        error: error => {
          this.authStatusListener.next(false);
        }
      })
    }
    else
    {
      this.http.post<any>(BackendUrl + "/login/", { username: username, password: null, access_token: access_token}).pipe(take(1)).subscribe({
        next: response => {
          localStorage.setItem('token', response.token);
          this.userService.getCurrentUser(true);
          this.userService.getCurrentUserDataListener().pipe(take(1)).subscribe({
            next: userData => {
              if (userData == null) {
                this.authStatusListener.next(false);
              }
              else {
                this.isAuthenticated = true;
                userData = typeof userData === 'string' ? JSON.parse(userData) : userData;
                userData = this.prepareUserAfterLogin(userData);
                localStorage.setItem('currentUser', JSON.stringify(userData));
                switch(userData.language)
                {
                  case 0 :
                    localStorage.setItem('usedLanguage', 'sv');
                  break;
                  case 1:
                    localStorage.setItem('usedLanguage', 'en');
                  break;
                  case 2:
                    localStorage.setItem('usedLanguage', 'fi');
                  break;
                  case 3:
                    localStorage.setItem('usedLanguage', 'no');
                  break;
                  case 4:
                    localStorage.setItem('usedLanguage', 'da');
                  break;
                  case 5:
                    localStorage.setItem('usedLanguage', 'zh');
                  break;
                  default:
                    localStorage.setItem('usedLanguage', 'sv');
                  break;
                }
                this.setTokenTime();
                this.organisationService.getOrganisation(userData.root_organisation_id);
                this.organisationService.getOrganisationOrgDataListener().pipe(take(1)).subscribe({
                  next: organisation => {
                    // A recursive function to get All departments of an organisation
                        // the function must be defined here but used later
                        let startPoint = organisation;
                        let searchId = [];
                        let idArray=[];
                        let allOrganisations=[];
                        idArray.push(organisation.id);
                        allOrganisations.push(organisation);

                          function getId (startPoint){
                            searchId.push(startPoint.id);
                            startPoint.orgs.forEach(element => {
                              if(searchId.indexOf(element.id)<0){
                                idArray.push(element.id);
                                allOrganisations.push(element);
                                getId(element);
                              }
                            });
                          }
                    if (organisation == null) {
                      this.authStatusListener.next(false);
                    }
                    else
                    {
                      localStorage.setItem('rootOrganisation', JSON.stringify(organisation));
                      localStorage.setItem('selectedOrganisation', JSON.stringify(organisation));

                      // Get all departments
                      getId(startPoint);


                      if (userData.is_local_user == 1 || userData.is_local_admin == 1 || userData.is_guest == 1||
                        (!userData.is_admin && !userData.is_super_user && !userData.is_super_admin && !userData.is_maintenance_user && !userData.is_readonly_user &&
                         !(userData.is_group_admin == 1 || userData.is_group_admin === true || userData.is_group_admin === '1'))) {
                          if ( userData.is_guest==1 && ( dep && dep != null && dep != '' ) ) {
                            for (var j = 0; j < allOrganisations.length; j++) {
                              if (dep == allOrganisations[j].id) {
                                localStorage.setItem('selectedDepartment', JSON.stringify(allOrganisations[j]));
                                this.authStatusListener.next(true);
                                this.navigateAfterLogin(userData);
                              }
                            }
                          } else {

                        userData.LocalUserDepartments = [];

                        // if (userData.department == null || userData.department.trim() == "" && userData.is_local_user_department.trim() == "") {
                        if ((!userData.department||userData.department.trim() == ""||userData.department==0)
                              &&(!userData.is_local_user_department||userData.is_local_user_department.trim() == ""||userData.is_local_user_department==0)) {
                          userData.LocalUserDepartments.push(userData.root_organisation_id.trim());
                        } else {
                          userData.LocalUserDepartments.push(userData.department);
                          var departmentArrayTemp = userData.is_local_user_department.split(',');
                          for (let value of departmentArrayTemp) {
                            if (value != ""){
                            userData.LocalUserDepartments.push(value.trim());
                            }
                          }

                          let needsToBeUpdated = false;
                          userData.LocalUserDepartments.forEach(element => {
                            if ( element == userData.root_organisation_id ){
                              // Ignoring the root organisation
                            } else {
                              let subOrgs = this.utilService.getAllSubdepartments(allOrganisations.find(org => org.id === element), true);
                              if (typeof subOrgs === 'string') {
                                subOrgs = [subOrgs];
                              }
                              if (Array.isArray(subOrgs)) {
                                for (let value of subOrgs) {
                                  if (userData.LocalUserDepartments.indexOf(value) == -1) {
                                    needsToBeUpdated = true;
                                    userData.LocalUserDepartments.push(value.trim());
                                  }
                                }
                              }
                            }
                          });

                          if (needsToBeUpdated) {
                            // Updates the values in local storage
                            let tempUser = JSON.parse(localStorage.getItem('currentUser'));
                            tempUser.is_local_user_department = userData.LocalUserDepartments.join(',');
                            localStorage.setItem('currentUser', JSON.stringify(tempUser));
                          }
                        }

                        if ((userData.department != null) && (userData.department != '')) {
                          for (var j = 0; j < allOrganisations.length; j++) {
                            if (userData.department == allOrganisations[j].id) {
                              localStorage.setItem('selectedDepartment', JSON.stringify(allOrganisations[j]));
                              this.authStatusListener.next(true);
                              //window.location.href = '/';
                              this.navigateAfterLogin(userData);
                            }
                          }
                        }
                        else {
                        for (let i = 0; i < userData.LocalUserDepartments.length; i++) {
                          for (var j = 0; j < allOrganisations.length; j++) {
                            if (userData.LocalUserDepartments[i] == allOrganisations[j].id) {
                              localStorage.setItem('selectedDepartment', JSON.stringify(allOrganisations[j]));
                              this.authStatusListener.next(true);
                              // window.location.href = '/';
                              this.navigateAfterLogin(userData);
                            }
                          }
                        }
                      }
                      }
                      } else {
                        if ( dep && dep != null && dep != '' ) {
                          for (var j = 0; j < allOrganisations.length; j++) {
                            if (dep == allOrganisations[j].id) {
                              localStorage.setItem('selectedDepartment', JSON.stringify(allOrganisations[j]));
                              this.authStatusListener.next(true);
                              //window.location.href = '/';
                              this.navigateAfterLogin(userData);
                            }
                          }
                        }
                        else if ((userData.department != null) && (userData.department != '')) {
                          for (var j = 0; j < allOrganisations.length; j++) {
                            if (userData.department == allOrganisations[j].id) {
                              localStorage.setItem('selectedDepartment', JSON.stringify(allOrganisations[j]));
                              this.authStatusListener.next(true);
                              //window.location.href = '/';
                              this.navigateAfterLogin(userData);
                            }
                          }
                        } else {
                          for (var j = 0; j < allOrganisations.length; j++) {
                            if (userData.root_organisation_id == allOrganisations[j].id) {
                              localStorage.setItem('selectedDepartment', JSON.stringify(allOrganisations[j]));
                              this.authStatusListener.next(true);
                              this.navigateAfterLogin(userData);
                            }
                          }
                        }
                      }
                    }
                  },
                  error: error => {
                    this.authStatusListener.next(false);
                  }
                })
              }
            },
            error: error => {
              this.authStatusListener.next(false);
            }
          })
        },
        error: error => {
          this.authStatusListener.next(false);
        }
      })
    }
  }

  setTokenTime() {
    var date=Date.now()+12*60*60*1000;
    localStorage.setItem('tokenTime', date.toString());
  }

  logout() {
    this.token = null;
    this.userId = null;
    this.authStatusListener.next(false);
    this.isAuthenticated = false;
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('tokenTime');
    var usedLanguage = localStorage.getItem('usedLanguage');
    localStorage.clear();
    localStorage.setItem('usedLanguage',usedLanguage);
    window.location.href = '/';
    // this.router.navigate(['/login']);
  }
}

